import { animate, style, transition, trigger } from '@angular/animations';
import { MuiAnimationTiming } from '../../utility';

export const muiFormFieldErrorsAnimation = trigger('inputErrors', [
  transition(':enter', [
    style({height: 0}),
    animate(MuiAnimationTiming.EASE_SHORT, style({height: '*'}))
  ]),
  transition(':leave', [
    style({height: '*'}),
    animate(MuiAnimationTiming.EASE_SHORT, style({height: 0}))
  ])
]);
